import {h, Component} from 'preact';
import MenuTimeFilter from "../desktop-components/menu-time-filter.jsx";

import * as P from "../mobile-templates/sports.jsx";

export default class MenuTimeFilterComponent extends MenuTimeFilter {
	render() {
		return <P.TimeFilterHolder>
			{this.getButtons().map(tab => (
				<P.TimeFilterBtn 
				  onClick={e => {this.setTimeFilter(tab.value)}} 
				  active={this.getCurrentFilter() == tab.value}>
					{tab.name}
				</P.TimeFilterBtn>
			))}
		</P.TimeFilterHolder>
	}
}